var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
  console.log(selectedDay, selectedDate, selectedMonth);
  timepicker.set('disable',[{ from: [12, 0], to: [12, 30] },
//                              { from: [12, 30], to: [15, 30] },
                             ]); 
                              
//   if(selectedDate.getDate() === 1 && selectedMonth === 4) {
//   	timepicker.set('disable',[{ from: [9, 15], to: [11, 45] },
//                               { from: [12, 30], to: [15, 30] },
//                              ]); 
//   }
	
}